import { CoreAdoptionGrade, LitLab } from 'common-types'
import BigBooks from 'components/arc-core/BigBooks'
import Framework from 'components/arc-core/Framework'
import LeveledLibrary75 from 'components/arc-core/LeveledLibrary75'
import PacingGuide from 'components/arc-core/PacingGuide'
import PacingGuideK from 'components/arc-core/PacingGuideK'
import PowerWordPlaybook from 'components/arc-core/PowerWordPlaybook'
import ReadAloudCollectionTwo from 'components/arc-core/ReadAloudCollectionTwo'
import ScienceTools from 'components/arc-core/ScienceTools'
import LitLabSection from 'components/core-adoption/LitLabSection'
import ThemeChartLitLabButton from 'components/core-adoption/ThemeChartLitLabButton'
import ThemeChartThemeButton from 'components/core-adoption/ThemeChartThemeButton'
import { Col, Row } from 'components/grid'
import React from 'react'
import Notebook from '../../arc-core/Notebook'

const GradeK = ({ litLab, themes, language, themeUnit, changeTheme, standard, isCompatible }: CoreAdoptionGrade) => {
	return (
		<div id="grade-k" className="w-full">
			<div className="flex">
				<p className="my-auto hidden w-8 font-bold text-slate-800 md:block">K</p>
				<div className="flex w-full">
					{/* Lit Lab Button */}
					{litLab && <ThemeChartLitLabButton changeTheme={changeTheme} litLab={litLab as LitLab} themeUnit={themeUnit} />}
					{/* Theme Buttons */}
					{themes.map((theme) => (
						<ThemeChartThemeButton key={theme.id} changeTheme={changeTheme} name={theme.name} id={theme.id} logo={theme.logo.file.url} themeUnit={themeUnit} />
					))}
				</div>
			</div>
			{litLab && themeUnit === litLab.id && (
				<LitLabSection isCompatible={isCompatible} litLab={litLab as LitLab} grade={0} gradeRange="k-2" language={language} standard={standard} />
			)}
			{themes.map((theme) => {
				if (themeUnit === theme.id) {
					return (
						<div key={theme.id}>
							<Row className="mt-6 justify-center">
								<Col width="w-1/2 md:w-1/3" className="material-column">
									<Framework
										image={standard === 'TEKS' ? theme?.frameworkCoverTeks?.gatsbyImageData : theme?.frameworkCover?.gatsbyImageData}
										fullFramework={standard === 'TEKS' ? theme?.fullFrameworkTeks?.file?.url : theme?.fullFramework?.file?.url}
										updatedAt={standard === 'TEKS' ? theme?.fullFrameworkTeks?.updatedAt : theme?.fullFramework?.updatedAt}
									/>
								</Col>
								{theme.pacingGuide && (
									<Col width="w-1/2 md:w-1/3" className="material-column">
										<PacingGuide images={standard === 'TEKS' ? theme.pacingGuideTeks : theme.pacingGuide} />
									</Col>
								)}
								{theme.bigBooks && (
									<Col width="w-1/2 md:w-1/3" className="material-column">
										<BigBooks image={theme.bigBooks.gatsbyImageData} />
									</Col>
								)}
								{theme.scienceTools && (
									<Col width="w-1/2 md:w-1/3" className="material-column">
										<ScienceTools image={theme.scienceTools.gatsbyImageData} />
									</Col>
								)}
								{theme.pacingGuideK && theme.pacingGuideKCover ? (
									<Col width="w-1/2 md:w-1/2" className="material-column">
										<PacingGuideK pages={standard === 'TEKS' ? theme.pacingGuideKTeks : theme.pacingGuideK} cover={theme.pacingGuideKCover.gatsbyImageData} />
									</Col>
								) : null}
								{theme.notebook && (
									<Col width="w-1/2 md:w-1/2" className="material-column">
										<Notebook
											isCompatible={isCompatible}
											lab={theme.labNotebook?.file.url}
											wordStudy={theme.wordStudyNotebook?.file.url}
											image={theme.notebook.gatsbyImageData}
											grade="K"
											updatedAt={[theme.labNotebook?.updatedAt, theme.wordStudyNotebook?.updatedAt]}
										/>
									</Col>
								)}
								{theme.readAloudCollection && (
									<Col width="w-full sm:w-1/2" className="material-column">
										<ReadAloudCollectionTwo baskets={theme.readAloudCollection} />
									</Col>
								)}
								{theme.leveledLibrary && (
									<Col width="w-full sm:w-1/2" className="material-column">
										<LeveledLibrary75 baskets={theme.leveledLibrary} />
									</Col>
								)}
							</Row>
						</div>
					)
				}
			})}
		</div>
	)
}

export default GradeK
